import { computed, effectScope, onScopeDispose, shallowReactive, watch } from 'vue';

// Read-only UI protection: a route can unmount before its transaction settles.
const sources = shallowReactive(new Set());
export const accountOperationLocked = computed(() => [...sources].some(source => !!source.value));
export function useAccountOperationLock(source) {
  sources.add(source);
  let detached = false;
  const scope = effectScope(true);
  const release = () => { sources.delete(source); scope.stop(); };
  scope.run(() => watch(source, value => { if (detached && !value) release(); }, { flush: 'sync' }));
  onScopeDispose(() => {
    detached = true;
    if (!source.value) release();
  });
}
